import React from "react";
import { Text } from "theme-ui";

const ArticleDate = ({
  publishedAt,
  updatedAt,
  i18nPublishedAt,
  i18nUpdatedAt,
}) => (
  <Text variant="caption" as="p" css={{ textAlign: "center" }}>
    {i18nPublishedAt} <em>{publishedAt}</em>, {i18nUpdatedAt.toLowerCase()}{" "}
    <em>{updatedAt}</em>.
  </Text>
);

export default ArticleDate;
